import IsServerSideRendering from '../utilities/IsServerSideRendering';

export default {
  setJSON: (key, value, timestamp) => {
    if (IsServerSideRendering) return;

    const stringValue = JSON.stringify({
      ...value,
      ...(timestamp ? { timestamp } : {})
    });
    localStorage.setItem(key, stringValue);
  },
  getJSON: key => {
    try {
      const {
        timestamp,
        ...storedValue
      } = JSON.parse(localStorage.getItem(key));

      const now = new Date();
      const isExpired = now > new Date(timestamp);
      return isExpired ? null : storedValue;
    } catch (err) {
      return null;
    }
  }
};
